module.exports = __webpack_public_path__ + "img/george-edward-malaga-trillo.04201dfb.png";